import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractOverviewComponent} from '../../common/abstract-overview.component';
import {DateTimeRange, FindMidUpdates, MidUpdate} from '@portbase/bezoekschip-service-typescriptmodels';
import {Observable} from 'rxjs';
import {sendQuery} from '../../common/utils';
import {Moment} from 'moment/moment';

@Component({
    selector: 'app-mid-overview',
    templateUrl: './mid-overview.component.html',
    styleUrls: ['./mid-overview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MidOverviewComponent extends AbstractOverviewComponent<MidUpdate> {
  entries : MidUpdate[] = []

  localStorageKey(): string {
    return "mid-overview";
  }

  doLoad = (start: Moment, end: Moment): Observable<MidUpdate[]> => sendQuery(
    'com.portbase.bezoekschip.common.api.transit.FindMidUpdates',
    <FindMidUpdates>{term: this.filterTerm, dateTimeRange: this.filterTerm ? null : <DateTimeRange>{
        start: start.toISOString(),
        end: end.toISOString()
      }
    },
    {caching: false, showSpinner: this.items.length === 0});

  doRender(entries: MidUpdate[]) {
    this.entries = entries;
  }
}
